/**
 * 格式化工具.
 */

/** 秒 → mm:ss(用于播放进度/时间区间, 设计规范要求数字使用 tabular-nums) */
export function formatTime(totalSeconds: number): string {
  const safe = Math.max(0, Math.floor(totalSeconds))
  const minutes = Math.floor(safe / 60)
  const seconds = safe % 60
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
}

/** 两位数字补零, 用于 `01 / 06` 这类序号 */
export function pad2(value: number): string {
  return String(Math.max(0, Math.floor(value))).padStart(2, '0')
}

/** ISO 时间 → YYYY-MM-DD(按本地时区; 用于会员有效期 / 邀请记录等展示) */
export function formatDate(iso: string | null | undefined): string {
  if (!iso) return ''
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return ''
  return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`
}

/** 把数值限制在 [min, max] 区间 */
export function clamp(value: number, min: number, max: number): number {
  return Math.min(Math.max(value, min), max)
}
